export default "__VITE_ASSET__BK2veQ6C__"